import type { TppEventSummary } from '../../../services/transitPassPool.service';
import type { TppEventEditSeed } from './TppEventEditModal';

/** 履歴行 → 編集モーダル seed */
export function tppEventSummaryToEditSeed(ev: TppEventSummary): TppEventEditSeed {
  const isUsage = ev.eventKind !== 'charge';
  return {
    id: ev.id,
    eventKind: isUsage ? 'usage' : 'charge',
    isOpenCheckout: isUsage && ev.checkoutStatus === 1,
    purpose: ev.purpose ?? '',
    place: ev.place ?? '',
    route: ev.route ?? '',
    amountNumber: ev.amountNumber,
    outDate: ev.outDate?.slice(0, 10) ?? '',
    inDate: ev.inDate?.slice(0, 10) ?? '',
    departmentLabel: ev.departmentLabel ?? '',
    borrowerName: ev.borrowerName ?? '',
  };
}
